export const navigation = {
    aria: {
        mainpage: 'Navigiere zur Startseite',
        uploadButton: 'Öffne den 3D Druck Konfigurator zum Dateiupload',
    },
    labels: {
        account: 'Account',
        language: 'Sprache',
        uploadFile: 'Datei hochladen',
        userPortal: 'Kundenportal',
    },
};
